import { render, staticRenderFns } from "./FooterSave.vue?vue&type=template&id=51195b2b"
import script from "./FooterSave.vue?vue&type=script&lang=js"
export * from "./FooterSave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports